import { render } from "./block.vue?vue&type=template&id=f5a9e342"
import script from "./block.vue?vue&type=script&lang=js"
export * from "./block.vue?vue&type=script&lang=js"
script.render = render

export default script